export default "__VITE_ASSET__01a12b08__"